import {
  Chart,
  PieController,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

Chart.register(PieController, ArcElement, Tooltip, Legend);


const highlights = document.querySelectorAll('.story-highlight');

highlights.forEach(function(highlight) {
    highlight.addEventListener('click', () => {
        const id = highlight.getAttribute('id');
        const storyModal = document.getElementById(highlight.getAttribute('data-modal'));
        const closeBtn = storyModal.querySelector('.close-story-modal');
        storyModal.showModal();

        closeBtn.addEventListener('click', () => {
            storyModal.close();
        });
    });
});


const chartInstances = new Map();

// Safely read JSON from data-attributes
function parseJSONAttr(el, attr, fallback = []) {
  const val = el.getAttribute(attr);
  if (!val) return fallback;
  try {
    return JSON.parse(val);
  } catch (e) {
    console.warn(`Invalid JSON in ${attr} on`, el, e);
    return fallback;
  }
}

// Default colors if data-chart-colors is not set
const defaultColors = [
  '#4B70E2', '#F28B50', '#FFD166', '#FF6E6E',
  '#06D6A0', '#9B5DE5', '#00BBF9', '#F15BB5'
];

function buildPieConfig(canvas) {
  const labels = parseJSONAttr(canvas, 'data-chart-labels');
  const values = parseJSONAttr(canvas, 'data-chart-values');
  const colors = parseJSONAttr(canvas, 'data-chart-colors', defaultColors)
    .slice(0, values.length);

  const total = values.reduce((a, b) => a + b, 0);
  const offsets = values.map(v => (v / total < 0.20 ? 50 : 0)); // <10% => 50px offset

  return {
    type: 'pie',
    data: {
      labels,
      datasets: [{
        data: values,
        backgroundColor: colors,
        offset: offsets,
        borderWidth:2,
      }]
    },
    options: {
      responsive: true,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false }
      },
      hover: { mode: null }
    }
  };
}

function initCharts() {
    try {
        document.querySelectorAll('.js-chart').forEach(canvas => {
            if (chartInstances.has(canvas)) return;
            const config = buildPieConfig(canvas);
            const chart = new Chart(canvas, config);
            chartInstances.set(canvas, chart);
        });
    }
    catch (err) {
    console.error("initCharts error:", err);
  }
}

//   document.addEventListener('DOMContentLoaded', initCharts);

initCharts();

const localNavLink = document.querySelectorAll('.local-nav a');
const body = document.querySelector('body');

localNavLink.forEach(link => {
  link.addEventListener('click', function() {
    body.classList.remove('nav-is-open');
  });
});